import React, { FC } from 'react';
import Select, { SingleValue } from 'react-select';
import { useField } from 'formik';

// Models
import { FormikDropdownOption } from '../../../models/Formik';

// Components
import FormikError from '../FormikError';

interface Props {
  name: string;
  options: FormikDropdownOption[];
  placeholder?: string;
  label?: string;
  subLabel?: string;
  className?: string;
  disabled?: boolean;
  onChange?: (value: FormikDropdownOption) => void;
}

const FormikDropdown: FC<Props> = ({
  name,
  options,
  label,
  subLabel,
  placeholder,
  className,
  onChange,
  disabled = false,
}) => {
  const [field, meta, helpers] = useField(name);

  className = `aea-dropdown ${className || ''}`;

  const handleChange = (newValue: SingleValue<FormikDropdownOption>) => {
    helpers.setValue(newValue?.value, true);
    if (onChange) {
      onChange(newValue?.value);
    }
  };

  const handleBlur = () => {
    helpers.setTouched(true, true);
  };

  const getValue = () => {
    if (field.value !== undefined && field.value !== null) {
      return options.find((option) => option.value === field.value)
    } else {
      return null;
    }
  };

  return (
    <div className="aea-form-dropdown-wrapper">
      {label && (
        <label className="aea-form-dropdown-label" htmlFor={name || name}>
          {label}
        </label>
      )}
      {subLabel && (
        <label className="aea-form-dropdown-sublabel">{subLabel}</label>
      )}
      <Select
        placeholder={placeholder}
        id={name}
        options={options}
        onChange={handleChange}
        onBlur={handleBlur}
        value={getValue()}
        className={className}
        isSearchable={false}
        isDisabled={disabled}
        blurInputOnSelect={false}
        classNamePrefix="aea-form-component"
      />
      {meta.touched && meta.error && <FormikError name={name} />}
    </div>
  );
};

export default FormikDropdown;
